import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { toPersianNum } from "../../assets/utils";
import { selectCurrentReqInfo } from "../../redux/currentReq/currentReq.selectors";
import { selectUserInfo } from "../../redux/user/user.selectors";
import BitsSingle from "../bitsSingle/bitsSingle.component";
import { BitsContStyled } from "./bitsList.styles";

const BitsList = ({
  bits,
  selectCurrentReqInfo,
  selectUserInfo,
  load_data,
}) => {
  return (
    <BitsContStyled>
      <div
        className="w-75 bg-white"
        style={{
          padding: "8px 12px",
          borderRadius: "12px",
        }}
      >
        {toPersianNum(bits.length)} پیشنهاد قیمت
      </div>

      <div className="bits-list">
        {bits?.map((bit) => (
          <BitsSingle
            load_data={load_data}
            key={bit.id}
            bit={bit}
            isMyReq={
              selectCurrentReqInfo.owner_id
                ? selectCurrentReqInfo.owner_id.id === selectUserInfo.id
                : null
            }
          />
        ))}
      </div>
    </BitsContStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectUserInfo: selectUserInfo,
  selectCurrentReqInfo: selectCurrentReqInfo,
});

export default connect(mapStateToProps)(BitsList);
